// JavaScript Document
var browserInfo;

(function ()
{
  if (browserInfo == null)
  {
    browserInfo = new Object();
  }

  // Browser check
  ua = navigator.userAgent;
  browserInfo.isMSIE = (navigator.appName == "Microsoft Internet Explorer");
  browserInfo.isMSIE5 = browserInfo.isMSIE && (ua.indexOf('MSIE 5') != -1);
  browserInfo.isMSIE50 = browserInfo.isMSIE && (ua.indexOf('MSIE 5.0') != -1);
  browserInfo.isMSIE55 = browserInfo.isMSIE && (ua.indexOf('MSIE 5.5') != -1);
  browserInfo.isMSIE60 = browserInfo.isMSIE && (ua.indexOf('MSIE 6.0') != -1);
  browserInfo.isMSIE70 = browserInfo.isMSIE && (ua.indexOf('MSIE 7') != -1);
  browserInfo.isMSIE80 = browserInfo.isMSIE && (ua.indexOf('MSIE 8') != -1);
  browserInfo.isMSIE90 = browserInfo.isMSIE && (ua.indexOf('MSIE 9') != -1); // lol
  browserInfo.isGecko = ua.indexOf('Gecko') != -1;
  browserInfo.isSafari = ua.indexOf('Safari') != -1;
  browserInfo.isOpera = ua.indexOf('Opera') != -1;
  browserInfo.isWebKit = (ua.indexOf('WebKit') != -1 && window.devicePixelRatio) ? true : false;
  browserInfo.isMac = ua.indexOf('Mac') != -1;
  browserInfo.isFirefox = ua.indexOf('Firefox') != -1;

  if (browserInfo.isFirefox)
  {
    var reVersion = /Firefox\/(\d)*\./;
    reVersion.test(ua);
    browserInfo.firefoxMajorVersion = RegExp.$1;
  }

  browserInfo.isNS7 = ua.indexOf('Netscape/7') != -1;
  browserInfo.isNS71 = ua.indexOf('Netscape/7.1') != -1;

  // Fake MSIE on Opera and if Opera fakes IE, Gecko or Safari cancel those
  if (browserInfo.isOpera)
  {
    browserInfo.isMSIE = true;
    browserInfo.isGecko = false;
    browserInfo.isSafari = false;
  }

  browserInfo.isIE = browserInfo.isMSIE;
  browserInfo.isRealIE = browserInfo.isMSIE && !browserInfo.isOpera;

  // Check if valid browser has execcommand support
  browserInfo.execCommand = (typeof (document.execCommand) != 'undefined');

  browserInfo.getBrowserCapabilitiesData = function()
  {
    var clientCookiesEnabled = false;
    var javascriptEnabled = true;
    var isPlatformCompatible = false;

    setCookie("TestClientCookie", "TestClientCookieValue");
    clientCookiesEnabled = (getCookie("TestClientCookie") == "TestClientCookieValue");
    setCookie("TestClientCookie", "", (new Date("1/1/2000")).toGMTString());
    isPlatformCompatible = javascriptEnabled && (browserInfo.isMSIE60 || browserInfo.isMSIE70 || browserInfo.isMSIE80 || browserInfo.isMSIE90 || browserInfo.isFirefox || browserInfo.isWebKit) && browserInfo.execCommand;

    return (browserInfo.isMSIE60 ? "MSIE 6.0;" : "") +
           (browserInfo.isMSIE70 ? "MSIE 7.0;" : "") +
           (browserInfo.isMSIE80 ? "MSIE 8.0;" : "") +
           (browserInfo.isMSIE90 ? "MSIE 9.0;" : "") +
           (browserInfo.isWebKit ? "WebKit;" : "") +
           (browserInfo.isFirefox ? "Firefox;" : "") +
           (browserInfo.firefoxMajorVersion ? "FirefoxMajorVersion:" + browserInfo.firefoxMajorVersion + ";" : "") +
           (browserInfo.execCommand ? "Exec Command;" : "") +
           (clientCookiesEnabled ? "Client Cookies Enabled;" : "") +
           (isPlatformCompatible ? "Platform Compatible;" : "") +
           (javascriptEnabled ? "Javascript Enabled;" : "");

  }

  function setCookie(name, value, expires, path, domain, secure)
  {
    document.cookie = name + "=" + escape(value) +
        ((expires) ? "; expires=" + expires : "") +
        ((path) ? "; path=" + path : "") +
        ((domain) ? "; domain=" + domain : "") +
        ((secure) ? "; secure" : "");
  }

  function getCookie(name)
  {
    var cookie = " " + document.cookie;
    var search = " " + name + "=";
    var setStr = null;
    var offset = 0;
    var end = 0;
    if (cookie.length > 0)
    {
      offset = cookie.indexOf(search);
      if (offset != -1)
      {
        offset += search.length;
        end = cookie.indexOf(";", offset)
        if (end == -1)
        {
          end = cookie.length;
        }
        setStr = unescape(cookie.substring(offset, end));
      }
    }
    return (setStr);
  }

})();

window.onload = function()
{
    var browserField = document.getElementById('idLoginBoxBrowserField');
    browserField.value = browserInfo.getBrowserCapabilitiesData();
}



// WEBPACK FOOTER //
// ./src/scripts/modules/waloginbox.js